import { useState } from 'react';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Field } from 'formik';
import Status from '../status';
import { Upload, Button, Progress, message } from 'antd';
import style from './style.module.scss';
import { DEFAULT_FILE_SIZE, checkFileType } from 'utilites/utils';
import { getMediaLink } from 'store/actions/DiscountCouponActions';
import { connect } from 'react-redux';

const UploadMediaWithS3 = ({
  name,
  label,
  isRequired,
  staticFileName,
  boxWidthStyle = '',
  uploadButtonName = 'Click to Upload',
  maxFileSize = DEFAULT_FILE_SIZE,
  acceptFileType = '',
  isDisabled = false,
  getMediaLink,
}) => {
  const [uploadedPercentage, setUploadedPercentage] = useState(0);
  const [fileName, setFileName] = useState('');
  const handleOnChange = ({ fileList }, setFieldValue, fieldName, setFieldError) => {
    const { size, originFileObj } = fileList[0] || {};
    setFileName(originFileObj?.name);

    if (!checkFileType(originFileObj?.type, acceptFileType)) {
      message.error('Invalid File Type');
      return;
    }
    if (size < maxFileSize) {
      getMediaLink({
        file: originFileObj,
        percent: setUploadedPercentage,
        setFieldValue,
        name,
      }).then((res) => {
        setFieldValue(fieldName, { ...fileList[0], ...res });
        setUploadedPercentage(0);
      });
    } else {
      setFieldError(fieldName, `Max file size should be less than ${maxFileSize / 1000} KB`);
    }
  };

  return (
    <Field name={name}>
      {({ field, meta: { error, touched }, form: { setFieldValue, setFieldError } }) => {
        return (
          <div className={style['upload-wrapper']}>
            {!!isRequired && (
              <p className={style['required-check']}>
                <Status isFilled={!(field.value === null || error)} />
              </p>
            )}
            <div>
              <div className={style['upload-row']}>
                <p className={style.label}>{label}</p>

                <div className={style['upload-actions']}>
                  <Upload
                    multiple={false}
                    showUploadList={false}
                    accept={acceptFileType}
                    onChange={(e) => handleOnChange(e, setFieldValue, field.name, setFieldError)}
                    maxCount={1}
                    listType="text"
                    disabled={isDisabled}
                    name={field.name}>
                    {!field.value && uploadedPercentage < 1 && (
                      <Button
                        className={`${style['download-btn']} ${boxWidthStyle}`}
                        icon={<UploadOutlined />}
                        type="primary"
                        ghost>
                        {uploadButtonName}
                      </Button>
                    )}
                  </Upload>

                  <UploadFileDisplay
                    field={field}
                    fileName={fileName || staticFileName}
                    setFieldValue={setFieldValue}
                    uploadedPercentage={uploadedPercentage}
                    setUploadedPercentage={setUploadedPercentage}
                    boxWidthStyle={boxWidthStyle}
                  />
                </div>
              </div>
              <a
                href={process.env.REACT_APP_COUPON_SAMPLE_FORMAT || ''}
                target="_blank"
                className={`${style['formField']} ${style['downloadAnchor']}`}>
                Download sample format
              </a>
            </div>

            {touched && error ? <p className={style.error}>{error}</p> : null}
          </div>
        );
      }}
    </Field>
  );
};

const UploadFileDisplay = ({
  field,
  fileName,
  setFieldValue,
  uploadedPercentage,
  setUploadedPercentage,
  boxWidthStyle,
}) => {
  return field?.value ? (
    <div className={`${style['delete-box']} ${boxWidthStyle}`}>
      {typeof field.value === 'object' && (
        <div className={style['text-wrapper-download']}>
          <a href={field?.value?.fileUrl} download target="_blank" rel="noreferrer">
            {field?.value?.fileName}
          </a>
        </div>
      )}
      {typeof field.value === 'string' && (
        <a href={field.value} className={style['text-wrapper-download']} download>
          {fileName}
        </a>
      )}
      <Button
        className={`${style['delete-btn']}`}
        onClick={() => {
          setFieldValue(field.name, null);
          setUploadedPercentage(0);
        }}
        icon={<DeleteOutlined />}
      />
    </div>
  ) : (
    <div>
      {Boolean(uploadedPercentage) && (
        <div className={`${style['download-box']} ${boxWidthStyle}`}>
          <div className={style['text-wrapper-download']}>{fileName}</div>
          <Progress width={30} type="circle" percent={uploadedPercentage} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  materialData: state.fabricQualities.materialData,
});
const mapDispatchToProps = (dispatch) => ({
  getMediaLink: (data) => dispatch(getMediaLink(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadMediaWithS3);
